import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDateTime,
  ODataCustom,
  ODataStringContains,
  ODataStringEndsWith,
  ODataStringEquals,
  ODataStringNotContains,
  ODataStringNotEquals,
  ODataStringStartsWith,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

function getUserHeaders(roles) {
  return [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      isIdentifier: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
      version: 1,
    }),
    new ODataHeader({
      title: "headers.users.user_name",
      type: new ODataString("UserName"),
      visible: false,
    }),
    new ODataHeader({
      title: "globals.firstname",
      type: new ODataString("FirstName"),
    }),
    new ODataHeader({
      title: "globals.lastname",
      type: new ODataString("LastName"),
    }),
    new ODataHeader({
      title: "globals.broker",
      type: new ODataString("Broker/Name"),
    }),
    new ODataHeader({
      title: "Broker Id",
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Broker/Id"),
    }),
    new ODataHeader({
      title: "headers.contacts.email",
      type: new ODataString("Email"),
    }),
    new ODataHeader({
      title: "views.myaccount.registration_date",
      type: new ODataDateTime("RegistrationDate", {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
    }),
    new ODataHeader({
      title: "headers.users.last_login_date",
      type: new ODataDateTime("LastLoginDate", {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
    }),
    new ODataHeader({
      title: "headers.users.login_status",
      type: new ODataBoolean("LoginStatus"),
    }),
    new ODataHeader({
      title: "views.users.roles",
      sortable: false,
      searchable: true,
      type: new ODataCustom("Roles", {
        getString: (item, type) => {
          var res = "";
          let itemRoles = [];
          let val = type.getValue(item, type);
          val.forEach((itemRole) => {
            let commonRoles = roles.filter((r) => r.Id === itemRole.RoleId);
            if (commonRoles.length > 0) itemRoles.push(commonRoles[0]);
          });
          res = itemRoles.map((r) => r.Name).join(", ");

          return res;
        },
        getHtml: (item, type) => {
          let itemRoles = [];
          let val = type.getValue(item, type);
          val.forEach((itemRole) => {
            let commonRoles = roles.filter((r) => r.Id === itemRole.RoleId);
            if (commonRoles.length > 0) itemRoles.push(commonRoles[0]);
          });
          if (itemRoles) {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap;'><span style='word-wrap: normal; white-space: nowrap; max-width: 200px'>" +
              itemRoles
                .map((u) => u.Name)
                .join(
                  "</span>, <span style='word-wrap: normal; white-space: nowrap'>"
                ) +
              "</span></div>"
            );
          }
          return "";
        },
        getWildcardFilter: (search) => {
          let roleIds = [];
          for (let role of roles) {
            if (role.Name.toLowerCase().indexOf(search.toLowerCase()) > -1) {
              roleIds.push(role.Id);
            }
          }
          if (roleIds.length > 0) {
            const ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            return `Roles/any(_e: ${ids})`;
          }
          return undefined;
        },
        getFilter: (callback) => {
          let roleIds = [];
          let ids = [];
          const res = callback("_e/RoleId");
          if (res.indexOf("not contains") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
            for (let role of roles) {
              if (
                role.Name.toLowerCase().indexOf(search.toLowerCase()) === -1
              ) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          } else if (res.indexOf("contains") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
            for (let role of roles) {
              if (role.Name.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          } else if (res.indexOf("eq") > -1) {
            const search = res
              .split("eq")[1]
              .slice(0, -1)
              .substring(2);
            for (let role of roles) {
              if (role.Name.toLowerCase() === search.toLowerCase()) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          } else if (res.indexOf("ne") > -1) {
            const search = res
              .split("ne")[1]
              .slice(0, -1)
              .substring(2);
            for (let role of roles) {
              if (role.Name.toLowerCase() !== search.toLowerCase()) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          } else if (res.indexOf("startswith") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
            for (let role of roles) {
              if (role.Name.toLowerCase().startsWith(search.toLowerCase())) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          } else if (res.indexOf("endswith") > -1) {
            const search = res
              .split(",")[1]
              .slice(0, -2)
              .substring(2);
            for (let role of roles) {
              if (role.Name.toLowerCase().endsWith(search.toLowerCase())) {
                roleIds.push(role.Id);
              }
            }
            if (roleIds.length > 0) {
              ids = roleIds.map((id) => `_e/RoleId eq ${id}`).join(" or ");
            } else {
              ids = roles
                .map((role) => `_e/RoleId ne ${role.Id}`)
                .join(" and ");
            }
            return `Roles/any(_e: ${ids})`;
          }
          return undefined;
        },
        operators: [
          new ODataStringContains(),
          new ODataStringNotContains(),
          new ODataStringEquals(),
          new ODataStringNotEquals(),
          new ODataStringStartsWith(),
          new ODataStringEndsWith(),
        ],
      }),
    }),
    new ODataHeader({
      title: "globals.plans",
      sortable: false,
      type: new ODataString("Plans[]/Translations[]/Name", {
        getString: (item) => {
          var res = "";
          if (item.Plans) {
            res = item.Plans.map((u) => translate2(u, "Name")).join(", ");
          }
          return res;
        },
        getHtml: (item, type) => {
          if (item.Plans) {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap;'><span style='word-wrap: normal; white-space: nowrap; max-width : 200px'>" +
              item.Plans.map((u) => translate2(u, "Name")).join(
                "</span>, <span style='word-wrap: normal; white-space: nowrap'>"
              ) +
              "</span></div>"
            );
          }
          return "";
        },
      }),
    }),
    new ODataHeader({
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Plans[]/Translations[]/LanguageCode"),
    }),
    new ODataHeader({
      title: "Plans Id",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Plans[]/Id"),
    }),
    new ODataHeader({
      title: "Plans UniqueIdentifier",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Plans[]/UniqueIdentifier"),
    }),
    new ODataHeader({
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Employers[]/Translations[]/LanguageCode"),
    }),
    new ODataHeader({
      title: "globals.employers",
      sortable: false,
      type: new ODataString("Employers[]/Translations[]/Name", {
        getString: (item) => {
          var res = "";
          if (item.Employers) {
            res = item.Employers.map((u) => translate2(u, "Name")).join(", ");
          }
          return res;
        },
        getHtml: (item, type) => {
          if (item.Employers) {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap;'><span style='word-wrap: normal; white-space: nowrap; max-width: 200px'>" +
              item.Employers.map((u) => translate2(u, "Name")).join(
                "</span>, <span style='word-wrap: normal; white-space: nowrap'>"
              ) +
              "</span></div>"
            );
          }
          return "";
        },
      }),
    }),
    new ODataHeader({
      title: "Employers Id",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Employers[]/Id"),
    }),
    new ODataHeader({
      title: "Employers UniqueIdentifier",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Employers[]/UniqueIdentifier"),
    }),
    new ODataHeader({
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Stores[]/Translations[]/LanguageCode"),
    }),
    new ODataHeader({
      title: "globals.stores",
      sortable: false,
      type: new ODataString("Stores[]/Translations[]/Name", {
        getString: (item) => {
          var res = "";
          if (item.Stores) {
            res = item.Stores.map((u) => translate2(u, "Name")).join(", ");
          }
          return res;
        },
        getHtml: (item, type) => {
          if (item.Stores) {
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap;'><span style='word-wrap: normal; white-space: nowrap; max-width: 200px'>" +
              item.Stores.map((u) => translate2(u, "Name")).join(
                "</span>, <span style='word-wrap: normal; white-space: nowrap'>"
              ) +
              "</span></div>"
            );
          }
          return "";
        },
      }),
    }),
    new ODataHeader({
      title: "Stores Id",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Stores[]/Id"),
    }),
    new ODataHeader({
      title: "Stores Number",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Stores[]/Number"),
    }),
    new ODataHeader({
      title: "Plans Tags",
      sortable: false,
      type: new ODataString("Plans[]/Tags[]/Name", {
        getString: (item, type) => {
          let all = item.Plans.map((o) => o.Tags).flat(1);
          let tags = [];
          for (const tag of all) {
            let missing = false;
            if (tag.Plans) {
              for (const tagPlan of tag.Plans) {
                if (
                  item.Plans.filter((o) => o.Id === tagPlan.Id).length === 0
                ) {
                  missing = true;
                }
              }
            } else {
              missing = true;
            }
            if (!missing) {
              if (tags.filter((o) => o.Id === tag.Id).length === 0) {
                tags.push(tag);
              }
            }
          }
          return tags
            .map((o) => o.Name)
            .sort()
            .join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
    }),
    new ODataHeader({
      title: "Plans Tags Id",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Plans[]/Tags[]/Id"),
    }),
    new ODataHeader({
      title: "Tags Plans",
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      type: new ODataString("Plans[]/Tags[]/Plans[]/Id"),
    }),

    new ODataHeader({
      title: "headers.users.confirmed",
      type: new ODataBoolean("IsConfirmed"),
    }),
    new ODataHeader({
      title: "globals.active",
      type: new ODataBoolean("IsActive"),
    }),
  ];
}
export default getUserHeaders;
